import * as React from "react";
import {
    LinearProgress,
} from "@mui/material";
import WebViewer from "@pdftron/pdfjs-express-viewer";
import { useEffect, useRef } from "react";

export const SimpelPdfViwer = (props) => {
    const { title, source, } = props;
    const viewer = useRef<HTMLDivElement>(null);
    const [loading, setLoading] = React.useState(true);
    const instanceRef = useRef<any>(null);

    useEffect(() => {
        // if (viewer.current != null && source !== "") {
        if (viewer.current && !instanceRef.current) {
            setLoading(true);
            WebViewer(
                {
                    path: "/webviewer/lib",
                    licenseKey: "odz1p7zRg12CVHoDzBOY",
                    disabledElements: [
                        "searchButton",
                        "menuButton",
                        "selectToolButton",
                        "viewControlsButton",
                        "textSelectButton",
                        "applyWatermark",
                        "moreButton",
                        "panToolButton",
                    ],
                    css: "/pdfstyle.css",
                },
                viewer.current
            ).then((instance) => {
                // now you can access APIs through the WebViewer instance
                instanceRef.current = instance;

                const { Core, UI } = instance;
                var FitMode = instance.UI.FitMode;
                instance.UI.useEmbeddedPrint(true);
                instance.UI.setFitMode(FitMode.FitWidth);

                instance.UI.loadDocument(source, {
                    filename: title,
                });

                if (source) {
                    instance.UI.loadDocument(source, { filename: title });
                }

                // adding an event listener for when a document is loaded
                Core.documentViewer.addEventListener("documentLoaded", () => {
                    setLoading(false);
                });

                // adding an event listener for when the page number has changed
                Core.documentViewer.addEventListener(
                    "pageNumberUpdated",
                    (pageNumber) => {
                        // console.log(`Page number is: ${pageNumber}`);
                    }
                );

                // adds a button to the header that on click sets the page to the next page
                instance.UI.setHeaderItems((header) => {
                    header.getHeader("default").push({
                        img: "icon-header-print-line",
                        index: -1,
                        type: "actionButton",
                        element: "printButton",
                        onClick: () => {
                            instance.UI.print();
                        },
                    });
                    header.getHeader("default").push({
                        img: "icon-header-download",
                        index: -1,
                        type: "actionButton",
                        element: "downloadButton",
                        onClick: () => {
                            instance.UI.downloadPdf();
                        },
                    });
                });
            });
            // } else {
            //     setLoading(false);
            // }
        } else if (instanceRef.current && source) {
            // Just load a new document without creating a new instance
            setLoading(true);
            instanceRef.current.UI.loadDocument(source, { filename: title });
        }
        // setLoading(false);
        // }, [source, viewer.current]);
    }, [source, title]);
    return (
        <>
            {loading && (
                <div
                    style={{
                        width: "35%",
                        height: "100vh",
                        left: "50%",
                        top: "100%",
                        position: "fixed",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    <LinearProgress color="primary" />
                </div>
            )}
            <div style={{ height: "100vh" }} className="webviewer" ref={viewer}></div>
        </>
    );
};
